module.exports = __webpack_public_path__ + "static/fathersdaybeer-03b5c6f799107dff503285fb1a24fddb.jpeg";